// Array of hex color codes
const colors = [
  "#6B4224",
  "#E20001",
  "#EFC41A",
  "#5E984C",
  "#3871C8",
  "#D2D2D2",
];

function getRandomElement(array) {
  if (array.length === 0) {
    return undefined; // Handle empty arrays
  }
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}

const pods = [
  {
    id: 17087974,
    title: "Welcome to the 'Office Of' Podcast",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087974-welcome-to-the-office-of-podcast.mp3",
    artwork_url: "https://storage.buzzsprout.com/zfekonh4oeuvyh26ulp05yrz1ykv",
    description:
      "<p>Welcome to the <em>Office Of</em> Podcast — where we talk candidly about what it means to be a man today...</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-05-02T13:00:00.000-04:00", // past
    duration: 82,
    hq: false,
    magic_mastering: false,
    guid: "Buzzsprout-17087974",
    inactive_at: null,
    custom_url: "",
    episode_number: 1,
    season_number: 1,
    episode_type: "trailer",
    explicit: false,
    private: false,
    total_plays: 67,
  },
  {
    id: 17087975,
    title: "Building Confidence Brick by Brick",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087975-building-confidence.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>We discuss the journey of building self-worth and overcoming self-doubt.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-06-09T13:00:00.000-04:00", // past
    duration: 95,
    hq: true,
    magic_mastering: false,
    guid: "Buzzsprout-17087975",
    inactive_at: null,
    custom_url: "",
    episode_number: 2,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 103,
  },
  {
    id: 17087976,
    title: "Lessons from Rock Bottom",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087976-lessons-from-rock-bottom.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>This episode explores personal breakdowns and the growth that follows.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-07-20T13:00:00.000-04:00", // past
    duration: 87,
    hq: true,
    magic_mastering: true,
    guid: "Buzzsprout-17087976",
    inactive_at: null,
    custom_url: "",
    episode_number: 3,
    season_number: 1,
    episode_type: "full",
    explicit: true,
    private: false,
    total_plays: 90,
  },
  {
    id: 17087977,
    title: "The Weight of Expectations",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087977-weight-of-expectations.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>We talk about family pressure, career choices, and staying true to yourself.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-08-15T13:00:00.000-04:00", // past
    duration: 72,
    hq: false,
    magic_mastering: true,
    guid: "Buzzsprout-17087977",
    inactive_at: null,
    custom_url: "",
    episode_number: 4,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 88,
  },
  {
    id: 17087978,
    title: "Father Figures and Role Models",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087978-father-figures.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>Reflections on the men who shaped us—for better or worse.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-09-10T13:00:00.000-04:00", // past
    duration: 76,
    hq: true,
    magic_mastering: true,
    guid: "Buzzsprout-17087978",
    inactive_at: null,
    custom_url: "",
    episode_number: 5,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 120,
  },
  {
    id: 17087979,
    title: "How to Start Over",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087979-how-to-start-over.mp3",
    artwork_url: "https://placehold.co/600x600",
    description: "<p>When you lose everything, how do you rebuild?</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-09-25T13:00:00.000-04:00", // past (just before today)
    duration: 80,
    hq: false,
    magic_mastering: false,
    guid: "Buzzsprout-17087979",
    inactive_at: null,
    custom_url: "",
    episode_number: 6,
    season_number: 1,
    episode_type: "full",
    explicit: true,
    private: false,
    total_plays: 70,
  },
  {
    id: 17087980,
    title: "Finding Peace in Chaos",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087980-peace-in-chaos.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>A conversation on mindfulness, rest, and reclaiming your time.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-10-05T13:00:00.000-04:00", // future
    duration: 78,
    hq: true,
    magic_mastering: false,
    guid: "Buzzsprout-17087980",
    inactive_at: null,
    custom_url: "",
    episode_number: 7,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 65,
  },
  {
    id: 17087981,
    title: "Letting Go of the Past",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087981-letting-go.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>This episode explores emotional baggage and how to move forward.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-10-12T13:00:00.000-04:00", // future
    duration: 74,
    hq: true,
    magic_mastering: true,
    guid: "Buzzsprout-17087981",
    inactive_at: null,
    custom_url: "",
    episode_number: 8,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 76,
  },
  {
    id: 17087982,
    title: "Brotherhood and Belonging",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087982-brotherhood.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>On male friendships and building community in adulthood.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-10-19T13:00:00.000-04:00", // future
    duration: 81,
    hq: false,
    magic_mastering: true,
    guid: "Buzzsprout-17087982",
    inactive_at: null,
    custom_url: "",
    episode_number: 9,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 92,
  },
  {
    id: 17087983,
    title: "Your Story, Your Rules",
    audio_url:
      "https://www.buzzsprout.com/2498844/episodes/17087983-your-story.mp3",
    artwork_url: "https://placehold.co/600x600",
    description:
      "<p>We wrap up season one with reflections, takeaways, and listener questions.</p>",
    summary: null,
    artist: "Yale Breslin",
    tags: "",
    published_at: "2025-10-26T13:00:00.000-04:00", // future
    duration: 85,
    hq: true,
    magic_mastering: true,
    guid: "Buzzsprout-17087983",
    inactive_at: null,
    custom_url: "",
    episode_number: 10,
    season_number: 1,
    episode_type: "full",
    explicit: false,
    private: false,
    total_plays: 110,
  },
];

const reversedByEpisode = [...pods].sort(
  (a, b) => b.episode_number - a.episode_number
);

window.addEventListener("DOMContentLoaded", () => {
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  // document.body.style.backgroundColor = randomColor;

  const overlay = document.querySelector(".newsletter-success-overlay");
  const successImg = document.querySelector(".success-img");
  // const about = document.querySelector("#about");
  // const listen = document.querySelector("#listen");
  // const contact = document.querySelector("#contact");
  // const logo = document.querySelector(".patch");
  // const o = document.querySelector(".banner__content");
  // const nav = document.querySelector(".nav");
  // const quote = document.querySelector(".quote");
  // const author = document.querySelector(".author");

  const about = document.querySelector("#about-section");
  const contact = document.querySelector("#contact-section");
  const privacy = document.querySelector("#privacy-section");
  const podcasts = document.querySelector("#podcasts");
  const bannerContent = document.querySelector(".banner__content");
  const logo = document.querySelector(".email-signup-banner");
  const footer = document.querySelector(".footer");
  const bg = document.querySelector(".shopify-section");

  const sectionMap = {
    about: { section: about, color: "green" },
    contact: { section: contact, color: "red" },
    privacy: { section: privacy, color: "brown" },
    pods: { section: podcasts, color: "blue" }, // optional: reset to blue for pods
  };

  // Hide all sections
  function hideAllSections() {
    Object.values(sectionMap).forEach((obj) => {
      obj.section.style.display = "none";
    });
  }

  function updateBannerColor(newColor) {
    logo.classList.remove("blue", "green", "red", "brown");
    logo.classList.add(newColor);
    footer.classList.remove("blue", "green", "red", "brown");
    footer.classList.add(newColor);
    bg.classList.remove("blue", "green", "red", "brown");
    bg.classList.add(newColor);
  }

  // Add click listeners to each nav button
  Object.keys(sectionMap).forEach((triggerId) => {
    // console.log(triggerId);
    const trigger = document.getElementById(triggerId);
    const { section, color } = sectionMap[triggerId];
    if (trigger && section) {
      trigger.addEventListener("click", (e) => {
        // console.log("click: ", e.target);
        hideAllSections();
        if (color == "blue") {
          section.style.display = "grid";
        } else {
          section.style.display = "flex";
        }

        if (triggerId === "pods") {
          bannerContent.style.display = "flex";
        } else {
          bannerContent.style.display = "none";
        }
        updateBannerColor(color);
      });
    }
  });

  if (overlay) {
    overlay.addEventListener("click", function () {
      overlay.remove();
    });
  }

  if (successImg && overlay) {
    successImg.addEventListener("click", function (event) {
      event.stopPropagation(); // Optional: prevent triggering overlay's click if nested
      overlay.remove();
    });
  }

  const url = "https://www.buzzsprout.com/api/2498844/episodes.json";

  const options = {
    headers: {
      Authorization: "Token token=5fdb4916e1c9c2be908cd73e0802781e",
    },
  };

  fetch(url, options)
    .then((res) => res.json())
    .then((data) => {
      let container = document.querySelector("#podcasts");
      // Reverse the order of episodes after fetching
      const now = new Date();
      let pastPodcasts = data.filter(
        (podcast) => new Date(podcast.published_at) < now
      );
      pastPodcasts.reverse();
      pastPodcasts = pastPodcasts.slice(1);
      const colors = ["gray", "red", "green", "yellow", "brown", "blue"];

      pastPodcasts.forEach((p, index) => {
        let pod = document.createElement("div");
        let title = document.createElement("div");
        let date = document.createElement("div");
        let player = document.createElement("div");
        let epNo = document.createElement("div");
        let play_button = document.createElement("div");

        title.innerHTML = p.title;

        let d = new Date(p.published_at);
        date.innerHTML = d.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });

        const colorClass = colors[index % colors.length]; // cycles through colors
        pod.className = `pod-ep ${colorClass}`;

        title.className = "main-copy";
        player.className = "pod-header audio-player";
        date.className = "pod-date";

        play_button.innerHTML = `
          <button class="audio-toggle" aria-label="Play">
            <svg class="icon icon-play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="white">
              <path d="M8 5v14l11-7z"/>
            </svg>
            <svg class="icon icon-pause hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="white">
              <path d="M6 19h4V5H6zm8-14v14h4V5h-4z"/>
            </svg>
          </button>
          <audio src="${p.audio_url}"></audio>
        `;

        let e = index + 1;
        epNo.innerHTML = "EPISODE " + e;

        player.appendChild(epNo);
        player.appendChild(play_button);
        pod.appendChild(player);
        pod.appendChild(title);
        pod.appendChild(date);
        container.prepend(pod);
      });
      let nextEpisodeNumber;
      // Add "Coming Soon" pod at the end
      if (pastPodcasts.length > 0) {
        nextEpisodeNumber = pastPodcasts.length + 1;
      } else {
        nextEpisodeNumber = 1;
      }

      const comingPod = document.createElement("div");
      const comingTitle = document.createElement("div");
      const comingPlayer = document.createElement("div");
      const comingEpNo = document.createElement("div");
      const comingPlayButton = document.createElement("div");

      comingTitle.innerHTML = "Coming Soon";
      comingTitle.className = "main-copy";

      comingEpNo.innerHTML = "EPISODE " + nextEpisodeNumber;

      comingPlayButton.innerHTML = `
        <button class="audio-toggle" aria-label="Play" style="opacity: 0; pointer-events: none;">
          <svg class="icon icon-play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="white">
            <path d="M8 5v14l11-7z"/>
          </svg>
          <svg class="icon icon-pause hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="white">
            <path d="M6 19h4V5H6zm8-14v14h4V5h-4z"/>
          </svg>
        </button>
      `;

      comingPlayer.className = "pod-header audio-player";
      comingPlayer.appendChild(comingEpNo);
      comingPlayer.appendChild(comingPlayButton);

      comingPod.className = `pod-ep ${
        colors[pastPodcasts.length % colors.length]
      }`;
      comingPod.appendChild(comingPlayer);
      comingPod.appendChild(comingTitle);
      container.prepend(comingPod);

      let currentlyPlayingAudio = null;

      document.querySelectorAll(".audio-player").forEach((player) => {
        const button = player.querySelector(".audio-toggle");
        const audio = player.querySelector("audio");
        const playIcon = player.querySelector(".icon-play");
        const pauseIcon = player.querySelector(".icon-pause");

        button.addEventListener("click", () => {
          if (audio.paused) {
            if (currentlyPlayingAudio && currentlyPlayingAudio !== audio) {
              currentlyPlayingAudio.pause();
            }
            audio.play();

            currentlyPlayingAudio = audio;
          } else {
            audio.pause();
          }
        });
        if (audio) {
          audio.addEventListener("play", () => {
            // console.log("play");
            playIcon.classList.add("hidden");
            pauseIcon.classList.remove("hidden");
          });

          audio.addEventListener("pause", () => {
            playIcon.classList.remove("hidden");
            pauseIcon.classList.add("hidden");
          });

          audio.addEventListener("ended", () => {
            playIcon.classList.remove("hidden");
            pauseIcon.classList.add("hidden");
          });
        }
      });
    });
});
